package navigation.settings.datetime

import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val dateTimeUiModule
    get() =
        module {
            factoryOf(::DateTimeScreenModel)
        }